import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from "jquery";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";

import {fetchTimelineRequest} from "../../../../actions/userAction";
import {showCarousal} from "../../../../actions/feedAction";
import FeedContent from "./../../../FeedContainer/FeedContent"
import FeedUser from "./../../../FeedContainer/FeedUser"
import FeedImage from "./../../../FeedContainer/FeedImage"
import FeedFooter from "./../../../FeedContainer/FeedFooter"
import FeedMenu from "./../../../FeedContainer/FeedMenu";
import ShareFeed from "./../../../FeedContainer/ShareFeed";
import { encrypt , decrypt , getParams } from "../../../../helpers/CryptoJs";
import {Pageloader} from "../../../Pageloader";
import { loader, pageloader} from '../../../../actions/utils';

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFeed             : [],
      pagination              : 0,
      current_user            : [],
      friend_suggestion       : [],
      post_id                 : 0,
      total_feed              : 0,
      total_page              : 0,
      toggleStatus            : '',
      toggle_feed_id          : '',
      toggleComment_feed_id   : '',
      currentActiveImage      : 0,
      carousalFeed            : 0,
      urlId                   : this.props.urlId,
    };
    this.fetchFeed       = this.fetchFeed.bind(this);
    this.handleScroll    = this.handleScroll.bind(this);
    this.toggleFunction  = this.toggleFunction.bind(this);
    this.showCommentList = this.showCommentList.bind(this);
    this.setActiveImage  = this.setActiveImage.bind(this);
  }
  componentDidMount(){
    pageloader(false);
    this.fetchFeed();
    window.addEventListener('scroll', this.handleScroll, true);
    localStorage.setItem('userpage','timeline');
  }
  componentWillUnmount() {
    localStorage.setItem('userpage','');
    localStorage.setItem('apicall','0');
  }
  fetchFeed(){
    localStorage.setItem('apicall','1');
    this.props.fetchTimelineRequest(this.state);
  }
  handleScroll(){
    if ($(window).scrollTop() + $(window).height()  ==  $(document).height()) {
      if((this.state.total_page > this.state.pagination) && (localStorage.getItem('userpage') == 'timeline') && (localStorage.getItem('apicall') == '0')){
        this.fetchFeed();
      }
    }
  }
  setActiveImage(activeIndex,feedId){
    let param = {
      activeIndex  : activeIndex,
      carousalFeed : feedId
    };
    this.props.showCarousal(param);
  }

  toggleFunction(toggleFeed){
    this.setState({
      toggleStatus    : (this.state.toggleStatus == 'is-collapsed') ? '' : 'is-collapsed',
      toggle_feed_id  : toggleFeed
    });
  }
  showCommentList(feedId){
    this.setState({
      toggleComment_feed_id: feedId
    })
  }
  UNSAFE_componentWillReceiveProps(nextProps,prevProps){
    

    
    if(nextProps.imagecarousal != this.props.imagecarousal){
      this.setState({
        currentActiveImage      : nextProps.imagecarousal.activeIndex,
        carousalFeed            : nextProps.imagecarousal.carousalFeed,
      })
    }
    let totalFeedObj = this.state.currentFeed; 

    /*fetched liked post response*/
    let matchedIndex = (totalFeedObj).map(function (obj) { 
      return obj.feed_id; 
    }).indexOf(nextProps.updatelikelist.feed_id);
  
    if(nextProps.listOfFeed.pagination == 0) {
        totalFeedObj =  [...nextProps.listOfFeed.listfeed];
    }else{
        let nextfeed = nextProps.listOfFeed.listfeed;
        if(nextfeed !== this.props.listOfFeed.listfeed){
          Object.keys(nextfeed).map((key) => {
              totalFeedObj.push(nextfeed[key]);
          });
        }
    }

    if(matchedIndex >= 0){
      totalFeedObj[matchedIndex].my_reaction    = nextProps.updatelikelist.my_reaction;
      totalFeedObj[matchedIndex].total_reaction = nextProps.updatelikelist.total_reaction;
    }
    
    this.setState({
      currentFeed       : totalFeedObj,
      pagination        : nextProps.listOfFeed.pagination + 1,
      current_user      : nextProps.listOfFeed.listfeed.current_user,
      friend_suggestion : nextProps.listOfFeed.listfeed.friend_suggestion,
      total_feed        : nextProps.listOfFeed.listfeed.total_counter,
      total_page        : Math.ceil(nextProps.listOfFeed.countertimeline / 25)
    },function(){
      localStorage.setItem('apicall','0');
      loader(false);
    }) 

    
    if((nextProps.userFriendDetails.id != decrypt(window.location.href.split('/')[4])) && (nextProps.userFriendDetails.id != undefined))
    { 
      this.setState({
        pagination : 0,
        urlId      : decrypt(window.location.href.split('/')[4])
      },function(){
        this.fetchFeed();
      })
    }
    
  }
  generateFeedContent(feedList){
   
    return Object.keys(feedList).map((item) => {
      let details = feedList[item];
      return (
        <div className="post_box" key={item}>
          <div className="center_post">
            <div className="post_header">
             
              <FeedUser 
                post_user={details.post_user} 
                post_date={details.post_date}
                ownimage={(this.props.currentUserDetails.user.id == details.post_user.post_user_id) ? 'yes' : 'no'}/>
              <FeedMenu 
                feed_id        = {details.feed_id} 
                post_id        = {details.post_id} 
                data_type      = {details.data_type} 
                toggle_feed_id = {this.state.toggle_feed_id} 
                toggleStatus   = {this.state.toggleStatus} 
                toggleFunction = {this.toggleFunction} 
                logged_in_user = {this.props.currentUserDetails} 
                post_user      = {details.post_user} 
                position       = "feed"
                data_type      = {details.data_type}
              />
            </div>
            <div className="post_body">
              <FeedContent content={details.content}/> 
              {this.checkPostImage(details)}
              {this.checkSharedPost(details)}
            </div>
          </div>
          <FeedFooter 
            total_reaction={details.total_reaction} 
            my_reaction={details.my_reaction} 
            total_comment={details.total_comment} 
            total_share={details.total_share} 
            data_type={details.data_type} 
            feed_id={details.feed_id} 
            post_id={details.post_id} 
            position="feed" 
            showCommentList={this.showCommentList} 
            toggleComment_feed_id={this.state.toggleComment_feed_id}
            feed_reaction_details = {details.feed_reaction_details}
            />
        </div>
      )
    })

  
  }
  checkSharedPost(details){
    return(
      (details.post_user_from.post_user_from_id != '') ? 
        <ShareFeed parent_post = {details.post_user_from} data_type={details.data_type}/>          
      : null
    )
  }
  checkPostImage(details){
    return (
      ((details.media_details).length > 0) ? 
          <div className="post_content">
            <FeedImage 
              media_details      = {details.media_details} 
              dynamic_class      = "post_img" 
              setActiveImage     = {this.setActiveImage} 
              currentFeed        = {details.feed_id}
              currentActiveImage = {this.state.currentActiveImage} 
              carousalFeed       = {this.state.carousalFeed} 
            />
          </div>
      : null
    )
  }
  render() {
    let feedList = this.state.currentFeed || {};
    let feedBox = this.generateFeedContent(feedList);
    return (
      
      <div id="post_arr">
        {feedBox}
        <Pageloader/> 
      </div>
      
    );
  }
}
const mapStateToProps = state => {
  return {
    listOfFeed         : state.listtimeline, 
    lastCreatedPost    : state.lastpost,
    updatelikelist     : state.updatelikelist.likeFeedResponse,
    imagecarousal      : state.imagecarousal.imageCarousal,
    userFriendDetails  : state.frienddetail['friendDetail'],
    changetab          :  state.activetab.usertabindex
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchTimelineRequest: bindActionCreators(fetchTimelineRequest, dispatch),
    showCarousal        : bindActionCreators(showCarousal, dispatch),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Timeline));
